__turbopack_context__.v({
  "buttons": "header-module-scss-module__YAVP0W__buttons",
  "header": "header-module-scss-module__YAVP0W__header",
  "inner": "header-module-scss-module__YAVP0W__inner",
  "link": "header-module-scss-module__YAVP0W__link",
  "link--highlighted": "header-module-scss-module__YAVP0W__link--highlighted",
  "list": "header-module-scss-module__YAVP0W__list",
  "logo-img": "header-module-scss-module__YAVP0W__logo-img",
  "right": "header-module-scss-module__YAVP0W__right",
  "wrapper": "header-module-scss-module__YAVP0W__wrapper",
});
